import React from 'react';

const IconEye: React.FC<JSX.IntrinsicElements['svg']> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 9.16559C10.437 9.16559 9.16598 10.4366 9.16598 11.9996C9.16598 13.5626 10.437 14.8336 12 14.8336C13.562 14.8336 14.834 13.5626 14.834 11.9996C14.834 10.4366 13.562 9.16559 12 9.16559ZM12 15.8336C9.88598 15.8336 8.16598 14.1136 8.16598 11.9996C8.16598 9.88559 9.88598 8.16559 12 8.16559C14.114 8.16559 15.834 9.88559 15.834 11.9996C15.834 14.1136 14.114 15.8336 12 15.8336ZM3.33898 11.9996C4.46198 13.2426 7.96598 16.7176 12 16.7176C16.044 16.7176 19.541 13.2436 20.662 11.9996C19.539 10.7576 16.034 7.28159 12 7.28159C7.96598 7.28159 4.46198 10.7566 3.33898 11.9996ZM12 18.1186C6.43098 18.1186 2.04898 12.6656 1.86498 12.4346C1.66398 12.1796 1.66398 11.8196 1.86498 11.5646C2.04898 11.3326 6.43098 5.88159 12 5.88159C17.569 5.88159 21.951 11.3326 22.135 11.5646C22.336 11.8196 22.336 12.1796 22.135 12.4346C21.951 12.6656 17.569 18.1186 12 18.1186Z"
      fill="currentColor"
    />
  </svg>
);

export default IconEye;
